import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/site';
export function FaqSection() {
  return <section id="faq" className="bg-ivory-200 py-24 lg:py-32" data-id="element-87" data-mp="1bm3gpjeto4zd">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 lg:px-10" data-id="element-88" data-mp="1gj3njwjhxbrj">
        <SectionHeading eyebrow="Questions" title={<>
              Answered <span className="italic text-brass" data-id="element-90" data-mp="289q7p1t4mv5f">plainly</span>.
            </>} description="If yours is not here, call us — you will reach a person who installs, not a call center." data-id="element-89" data-mp="24a91u79sfvzq" />

        <Accordion type="single" collapsible className="w-full border-t border-ivory-300" data-id="element-91" data-mp="1zh6gunj2tuv5">
          {faqs.map((faq, index) => <AccordionItem key={faq.q} value={`faq-${index}`} className="border-b border-ivory-300" data-id="element-92" data-mp="2n5z8i7so1gjy" data-mpi={index}>
              <AccordionTrigger className="py-6 text-left font-display text-xl text-ink hover:no-underline lg:text-2xl" data-id="element-93" data-mp="14wbx0v3dizxt">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="pb-7 pr-6 text-base leading-relaxed text-muted-foreground" data-id="element-94" data-mp="1eln4yeeixyk4">
                {faq.a}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}